/**
 * FeedbackOutboxRunner — single-mount driver that flushes the feedback
 * outbox on mount and at a 5-minute interval. It also kicks a flush on
 * the browser `online` event so a freshly-recovered network drains the
 * queue immediately rather than waiting for the next tick.
 *
 * Why a dedicated component? Earlier the flush effect lived inside the
 * `useFeedback()` hook, which meant every consumer of the hook (one per
 * mounted FeedbackButton) drove its own setInterval — N timers chasing
 * the same outbox. Centralizing here gives us exactly one timer.
 */

import { useEffect } from "react";
import { flushFeedbackOutbox } from "@/hooks/useFeedback";

const RETRY_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export function FeedbackOutboxRunner() {
  useEffect(() => {
    void flushFeedbackOutbox();
    const id = setInterval(() => void flushFeedbackOutbox(), RETRY_INTERVAL_MS);
    const onOnline = () => void flushFeedbackOutbox();
    window.addEventListener("online", onOnline);
    return () => {
      clearInterval(id);
      window.removeEventListener("online", onOnline);
    };
  }, []);
  return null;
}
